import { FC } from 'react';

import { Button } from '../../button';
import { Modal } from '../Modal';
import { ModalOpener } from '../ModalOpener';

type Props = {
  confirmText: string;
  content: string;
  isLoading?: boolean;
  onCancel?: () => void;
  onConfirm: () => void;
  title: string;
};

export const OneButtonModal: FC<Props> = ({ confirmText, content, isLoading, onCancel, onConfirm, title }) => {
  const onClickCancel = () => {
    if (!isLoading) {
      onCancel?.();
      ModalOpener?.instance.close();
    }
  };

  return (
    <Modal onCancel={onClickCancel}>
      <Modal.Header onCancel={onClickCancel}>{title}</Modal.Header>
      <Modal.Content>
        <p>{content}</p>
      </Modal.Content>
      <Modal.Buttons>
        <Button
          loading={isLoading}
          onClick={() => {
            onConfirm?.();
            ModalOpener?.instance.close();
          }}
          theme="negative"
        >
          {confirmText}
        </Button>
      </Modal.Buttons>
    </Modal>
  );
};
